(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nym-google-reviews"] && !Shopify.designMode) return;
  try {
    
  class NymReviewsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.nym-greviews__track');
      this.querySelectorAll('.nym-greviews__arrow').forEach((btn) => {
        btn.addEventListener('click', () => {
          const card = this.track.querySelector('.nym-greviews__card');
          const step = card ? card.getBoundingClientRect().width + 16 : 300;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: step * Number(btn.dataset.dir), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      this.querySelectorAll('.nym-greviews__card').forEach((card) => {
        const text = card.querySelector('.nym-greviews__text');
        const more = card.querySelector('.nym-greviews__more');
        if (!text || !more) return;
        if (text.scrollHeight > text.clientHeight + 2) {
          more.hidden = false;
          more.addEventListener('click', () => {
            const open = card.classList.toggle('is-open');
            more.textContent = open ? 'Show less' : 'Read more';
          });
        }
      });
    }
  }
  if (!customElements.get('nym-reviews-slider')) customElements.define('nym-reviews-slider', NymReviewsSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nym-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nym-hero-slides]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-nym-slide]');
    var dots = hero.querySelectorAll('[data-nym-dot]');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var interval = Math.max(3, parseInt(hero.dataset.interval || '6', 10)) * 1000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (reduce) return; stop(); timer = setInterval(function () { show(i + 1); }, interval); }
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.dataset.nymDot, 10)); start(); }); });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
    start();
  });

  } catch(e) { console.error(e); }
})();
})();
